import { AdQueue } from './ad-queue.model';

export class Firestick {
  id: string;
  fileType: string;
  defaultUrl: string;
  adQueue: AdQueue[];
  operateType: string;
  storeHours: any;
  queuePlayLength: number;
  currentAdIndex: number;
  currentPlayingTime: number;

  constructor(
    id?: string,
    fileType?: string,
    defaultUrl?: string,
    adQueue?: AdQueue[],
    operateType?: string,
    storeHours?: any,
    queuePlayLength?: number,
    currentAdIndex?: number,
    currentPlayingTime?: number
  ) {
    this.id = id;
    this.fileType = fileType || null;
    this.defaultUrl = defaultUrl;
    this.adQueue = adQueue || [];
    this.operateType = operateType || null;
    this.storeHours = storeHours || null;
    this.queuePlayLength = queuePlayLength;
    this.currentAdIndex = currentAdIndex || null;
    this.currentPlayingTime = currentPlayingTime || null;
  }
}
